import { useTheme } from '@material-ui/core/styles';
import { any, string } from 'prop-types';
import React from 'react';
import Tag from 'src/components/2.2.0/deal-ngon/Tag';

export default function TagSalePrice({ off, suffix }) {
  const theme = useTheme();

  if (off <= 0) return null;

  return (
    <Tag
      content={`Giảm ${Math.round(off)}${suffix}`}
      style={{ color: theme.palette.common.white, backgroundColor: '#F51D2C' }}
    />
  );
}

TagSalePrice.propTypes = {
  off: any,
  suffix: string
};

TagSalePrice.defaultProps = {
  off: 0,
  suffix: '%'
};
